import { UserWallets } from '../UserWallets';

import { ScUserPanel, ScUserPanelMobile } from './styled';

export const UserPanel = () => {
  return (
    <ScUserPanel>
      <UserWallets />
    </ScUserPanel>
  );
};

export const UserPanelMobile = () => {
  return (
    <ScUserPanelMobile>
      <UserWallets menuMode />
    </ScUserPanelMobile>
  );
};
